import ProfileImageUpload from './ProfileImageUpload.js'

export default ProfileImageUpload
